import React, { FC } from 'react';
import { Route } from 'react-router';

import { EquipmentsGuide } from '../components/equipments-guide/';
import EquipmentsGuideEdit from '../components/equipments-guide/edit';

const EquipmentsGuidePage: FC = () => {
  return (
    <>
      <Route
        exact
        path="/equipments-guide/edit/:id"
        component={EquipmentsGuideEdit}
      />
      <Route exact path="/equipments-guide/" component={EquipmentsGuide} />
    </>
  );
};

export default EquipmentsGuidePage;
